import './Work.css';
import { useState } from 'react';

const images = require.context('../../../media/Collab/Shrekd', false, /\.(png|jpe?g|gif|webp|svg)$/);
const screenshots = images.keys().map(images);

function Collab() {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <section className="gallery">
      <h2>Collaborations</h2>
      <div className="collab-panes">
        <div className="collab-pane">
          <div className="collab-header">
            <h3>Shrek'd</h3>
            <p>Concordia Game Jam 2026</p>
            <a
              className="play-button"
              href="https://foxcott.itch.io/shrekd"
              target="_blank"
              rel="noreferrer"
            >
              ▶ Play Now
            </a>
          </div>
          <div className="collab-main-image">
            <img src={screenshots[activeIndex]} alt={`Screenshot ${activeIndex + 1}`} loading='lazy' />
          </div>
          <div className="collab-thumbnail-strip">
            {screenshots.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`Thumbnail ${i + 1}`}
                className={`collab-thumb ${i === activeIndex ? 'active' : ''}`}
                onClick={() => setActiveIndex(i)}
                loading="lazy"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
export default Collab;